import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import ScenarioTaskListPage from './pages/scenarioTaskList';
import ScenarioTaskPage from './pages/scenarioTask';
import OrganizationManagementPage from './pages/organization';
import CreateOrganizationPage from './pages/organization/create';
import OrganizationDetailPage from './pages/organization/detail';
import EacManagementPage from './pages/eac-management';
import EbpEacEnhancementPage from './pages/ebp-eac-enhancement';
import CashflowForecastDashboardPage from './pages/cashflow-forecast-dashboard';

// 获取基础路径，移除末尾的斜杠（如果有的话）
const getBasename = () => {
  const basePath = import.meta.env.VITE_BASE_PATH || '/';
  return basePath === '/' ? '' : basePath.replace(/\/$/, '');
};

export const router = createBrowserRouter(
  [
    {
      path: '/login',
      element: <Login />,
      handle: {
        title: '登录',
      },
    },
    {
      path: '/eac-management',
      element: <ProtectedRoute><EacManagementPage /></ProtectedRoute>,
      handle: {
        title: 'EAC',
      },
    },
    {
      path: '/ebp-eac-enhancement',
      element: <ProtectedRoute><EbpEacEnhancementPage /></ProtectedRoute>,
      handle: {
        title: 'EBP系统EAC智能化提升',
      },
    },
    {
      path: '/cashflow-forecast-dashboard',
      element: <ProtectedRoute><CashflowForecastDashboardPage /></ProtectedRoute>,
      handle: {
        title: '现金流预测看板',
      },
    },
    {
      path: '/',
      element: <ProtectedRoute><Layout /></ProtectedRoute>,
      children: [
        {
          index: true,
          element: <Navigate to="/scenario-task-list" replace />,
        },
        {
          path: 'scenario-task-list',
          element: <ScenarioTaskListPage />,
          handle: {
            title: '场景任务运行记录',
          },
        },
        {
          path: 'scenario-task',
          element: <ScenarioTaskPage />,
          handle: {
            title: '运行新任务',
          },
        },
        {
          path: 'organization',
          element: <OrganizationManagementPage />,
        },
        {
          path: 'organization/create',
          element: <CreateOrganizationPage />,
        },
        {
          path: 'organization/:id',
          element: <OrganizationDetailPage />,
        },
      ],
    },
  ],
  {
    basename: getBasename(),
  }
);
